// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"0a57aa8e","453":"30bc8930"}[chunkId] + ".chunk.js";
};